<template>
  <div class="text-center">
    <v-dialog persistent v-if="visible" v-model="visible" width="800">
      <v-card class="not-margin pt-0 pr-0 pl-0">
        <v-toolbar dark color="primary">
          <div class="text-center">
            <v-icon>mdi-pencil</v-icon>
            {{ edit ? "Editar" : "Cadastrar" }} Habilidade
          </div>
        </v-toolbar>
        <div class="container dialog">
          <v-form ref="form">
            <v-row class="d-flex justify-center mt-7">
              <v-col cols="12">
                <v-text-field
                  v-model="content.nome"
                  label="Habilidade*"
                  counter="25"
                  maxlength="25"
                  outlined
                  dense
                  :rules="[(v) => $required(v), (v) => $max(v, 25)]"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="content.codigo"
                  label="Código da Habilidade*"
                  dense
                  outlined
                  counter="25"
                  maxlength="25"
                  persistent-hint
                  hint="O código informado deve ser o mesmo disponibilizado pelo MEC."
                  v-transform-case
                  :rules="[(v) => $required(v), (v) => $max(v, 25)]"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-textarea
                  v-model="content.descricao"
                  label="O que será avaliado*"
                  dense
                  rows="4"
                  counter="2500"
                  maxlength="2500"
                  outlined
                  :rules="[(v) => $required(v), (v) => $max(v, 2500)]"
                ></v-textarea>
              </v-col>
            </v-row>
          </v-form>
          <div class="mt-4">
            <v-icon color="warning" class="mr-2">mdi-alert-circle</v-icon>
            <span>Os campos marcados com asterisco(*) são obrigatórios.</span>
          </div>
        </div>
        <sca-buttons
          @click="salvar()"
          @cancel="$emit('onClose')"
          :actionText="edit ? 'Editar' : 'Salvar'"
        ></sca-buttons>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { DialogProps } from '~/commons/classes/dialog-props';
import { Habilidade } from '~/commons/classes/habilidade';
import HabilidadeService from '~/services/habilidade.service';

export default {
  props: new DialogProps(Habilidade),
  mixins: [HabilidadeService],
  data: () => ({
    form: {
      lists: {
        listPermissoes: [],
      },
    },
  }),
  methods: {
    salvar() {
      const save = () => {
        return this.$swal({
          text: `Deseja ${this.edit ? "editar" : "cadastrar"} o registro?`,
          type: "warning",
          showCancelButton: true,
          confirmButtonText: `Confirmar`,
          cancelButtonText: `Cancelar`,
        }).then(() => {
          const habilidade = new Habilidade(this.content).format();
          return this.edit
            ? this.$editarHabilidade(habilidade, habilidade.id)
            : this.$cadastrarHabilidade(habilidade);
        });
      };
      if (this.$validarFormulario()) {
        save().then(({ data }) => {
          this.$notifySuccess(data.mensagem);
          this.$emit("onClose");
          this.$emit("onSave");
        });
      }
    },
  },
};
</script>
